export const WEEK_DAYS_SORTING = {
  MONDAY: 0,
  TUESDAY: 1,
  WEDNESDAY: 2,
  THURSDAY: 3,
  FRIDAY: 4,
  SATURDAY: 5,
  SUNDAY: 6,
};

export const GROUPS_WEEK_DAYS_SORTING = {
  WEEKDAYS: 0,
  SATURDAY: 1,
  SUNDAY: 2,
};
